<ng-container *ngIf="dataType">
  <ng-container [ngSwitch]="dataType">
    <ng-container *ngSwitchCase="'GPSFrame'">
      <app-frame-tree-item [node]="node"></app-frame-tree-item>
    </ng-container>
    <ng-container *ngSwitchCase="'StopPile'">
      <app-bus-stop-tree-item [node]="node"></app-bus-stop-tree-item>
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{ node.name }}
    </ng-container>
  </ng-container>
</ng-container>